import { BaseModel } from './base.model';

export class TableModelRequestModel extends BaseModel {

    per_page: number = 10;
    page: number = 0;
    search: any;
    location_uid: string;
    startDate: string;
    endDate: string;

}

export class TableModelResponseModel extends BaseModel {

    current_page: number = 1;
    first_page_url: string;
    from: number = 1;
    last_page: number;
    last_page_url: string;
    next_page_url: string;
    path: string;
    per_page: number = 5;
    prev_page_url: number;
    to: number;
    total: number;
}

export class TableFilterModel extends BaseModel {
    key: string;
    value: string;
}
